import React from "react"

import { TwoFactorAuthenticationForm } from "./Form"

export const TwoFactorAuthenticationScreenContent = () => <>
  <TwoFactorAuthenticationForm/>
</>